export enum PropertyColumn {
  SELECT = "select",
  CERTIF = "certif",
  PHOTO = "photo",
  NAME = "name",
  SALE_STATUS = "saleStatus",
  SELLING_PRICE = "sellingPrice",
  TYPE = "type",
  OWNER_NAME = "ownerName",
  SHARED_BY_NAME = "sharedByName",
  CITY = "city",
  NUM = "num",
  FLOOR = "floor",
  CERTIFICATION = "certification",
  EEMO_ID = "eemoId",
  DATE_CREATE = "dateCreate",
  CHILDREN = "children",
  ACTIONS = "actions",
}
